import React, { FunctionComponent, MouseEvent } from "react";

import { FormInterstitial } from "../../db/models/Form";
import { useTranslate } from "../translation/frontend";
import ArrowRightIcon from "./icons/ArrowRightIcon";
import CheckIcon from "./icons/CheckIcon";

interface InterstitialProps {
  page: FormInterstitial;
  onBack?: (ev: MouseEvent<HTMLButtonElement>) => void;
  onSkipToEnd?: (ev: MouseEvent<HTMLButtonElement>) => void;
  isLastPage: boolean;
  loading: boolean;
  showValidationError: boolean;
}

const Interstitial: FunctionComponent<InterstitialProps> = ({
  page,
  onBack,
  onSkipToEnd,
  isLastPage,
  loading,
  showValidationError,
}) => {
  const translate = useTranslate();

  return (
    <section className="form-group section report-details report-details--left">
      <div className="container--slim">
        <div className="content-styles">
          <div className="content-styles allow-cross-form-links" dangerouslySetInnerHTML={{ __html: page.body }} />
          {page.showSkipToEnd ? (
            <section className="section">
              <div className="report-paging__skip-to-end">
                <button
                  className="btn btn--skip-to-end btn--swipe btn--arrow"
                  name="_action"
                  value="skip-to-end"
                  onClick={onSkipToEnd}
                  formNoValidate
                  disabled={loading}
                >
                  <span>{translate("skipToEndLabel")}</span>
                  <span className="btn__arrow">
                    <ArrowRightIcon />
                  </span>
                </button>
              </div>
            </section>
          ) : null}
          <div className="report-details__paging">
            {page.confirm ? (
              <div className="field field--isRequired field--isSingle">
                <div className="options__option options__option--interstitial">
                  <div className="options__label">
                    <input
                      type="checkbox"
                      className="form-control options__check options__checkbox"
                      id="confirm"
                      required
                    />
                    <CheckIcon />
                    <div className="options__label-target">
                      <label htmlFor="confirm">{page.confirm}</label>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            {isLastPage ? (
              <div className="report-details__submit">
                {showValidationError ? (
                  <span className="report-paging__error continue is-invalid" role="alert">
                    {translate("pageIncompleteError")}
                  </span>
                ) : null}
                <button className="btn btn--continue" name="_action" value="next" disabled={loading}>
                  <span>{translate("sendReportLabel")}</span>
                  <span className="btn__arrow">
                    <ArrowRightIcon />
                  </span>
                </button>
              </div>
            ) : (
              <div className="report-details__continue">
                {showValidationError ? (
                  <span className="report-paging__error continue is-invalid" role="alert">
                    {translate("pageIncompleteError")}
                  </span>
                ) : null}
                <button
                  className="btn btn--continue btn--swipe btn--arrow"
                  name="_action"
                  value="next"
                  disabled={loading}
                >
                  <span>{translate("continueLabel")}</span>
                  <span className="btn__arrow">
                    <ArrowRightIcon />
                  </span>
                </button>
              </div>
            )}
            {onBack ? (
              <button
                className="btn btn--back btn--arrow"
                name="_action"
                value="back"
                formNoValidate
                onClick={onBack}
                disabled={loading}
              >
                <span className="btn__arrow">
                  <ArrowRightIcon />
                </span>
                <span>{translate("backLabel")}</span>
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Interstitial;
